var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import isEmpty from 'lodash.isempty';
import merge from 'lodash.merge';
import { forwardRef, useMemo } from 'react';
import { FactoryComponent, FactoryContent } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import useWatch from '../../../hooks/useWatch';
export var ContentContainerWithWatch = forwardRef(function (_a, ref) {
    var watch = _a.watch, props = __rest(_a, ["watch"]);
    var watchedValues = useWatch(watch);
    return _jsx(ContentContainerComponent, __assign({ ref: ref }, props, { watchedValues: watchedValues }));
});
export var ContentContainerComponent = forwardRef(function (_a, ref) {
    var design = _a.design, schema = _a.schema, component = _a.component, as = _a.as, values = _a.values, watchedValues = _a.watchedValues, content = _a.content, actions = _a.actions, config = _a.config, props = __rest(_a, ["design", "schema", "component", "as", "values", "watchedValues", "content", "actions", "config"]);
    return (_jsx(FactoryComponent, __assign({ ref: ref, "data-design": design, as: config.as || as, component: config.component || component, design: design, schema: schema, config: config, values: values, watchedValues: watchedValues }, props, config, { children: _jsx(FactoryContent, { parentDesign: design, config: config, content: content, values: values, watchedValues: watchedValues, autoIndex: true, actions: actions }) })));
});
export var ContentContainer = forwardRef(function (_a, ref) {
    var design = _a.design, propsConfig = _a.config, content = _a.content, props = __rest(_a, ["design", "config", "content"]);
    var _b = useDesign(design), schema = _b.schema, _c = _b.config, watch = _c.watch, config = __rest(_c, ["watch"]);
    var mergedConfig = useMemo(function () { return merge({}, config, propsConfig, { content: content }); }, [content, config, propsConfig]);
    if (isEmpty(mergedConfig.content))
        return false;
    if (!isEmpty(watch))
        return (_jsx(ContentContainerWithWatch, __assign({ design: design, ref: ref, schema: schema, config: mergedConfig, watch: watch }, props)));
    return (_jsx(ContentContainerComponent, __assign({ ref: ref, design: design, schema: schema, config: mergedConfig }, props)));
});
ContentContainer.displayName = 'ContentContainer';
